import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { getListApiKeysQueryKey, useCreateApiKey as useCreateApiKeyMutation } from '@/modules/api/codegen';
import { actions as messagesActions } from '@/modules/messages';

export const useCreateApiKey = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    return useCreateApiKeyMutation({
        mutation: {
            // Not awaited: the mutation's own `onSuccess` gates the caller's, and the reveal step
            // has no reason to wait behind a list refetch it does not read.
            onSuccess: () => {
                void queryClient.invalidateQueries({ queryKey: getListApiKeysQueryKey() });

                dispatch(messagesActions.displaySuccessMessage({ message: { id: 'api-keys.create.success' } }));
            },
            onError: () => dispatch(messagesActions.displayErrorMessage({ message: { id: 'api-keys.create.error' } })),
        },
    });
};
